import React from 'react';
import { Placeholder, Table } from 'react-bootstrap';

const LoadingTable = ({loadingCol}) => {
  return (
    <Table responsive striped bordered className='mt-4'>
      <thead className='bg-dark text-light'>
        <tr>
          {[...Array(loadingCol ?? 4)].map((_, index) => (
            <th scope="col" key={index}>
            <Placeholder as="p" animation="glow">
                <Placeholder xs={8} />
            </Placeholder>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {[...Array(10)].map((_, index) => (
          <tr key={index}>
            {[...Array(loadingCol ?? 4)].map((_, i) => (
            <td key={i}>
            <Placeholder as="p" animation="glow">
                <Placeholder xs={8} />
            </Placeholder>
             </td>
            ))}
          </tr>
        ))}
      </tbody>
    </Table>
  );
}

export default LoadingTable;
